/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'
import CrueltyFree from '../assets/images/glossary/cruelty-free.png'
import Employs from '../assets/images/glossary/employs-marginalized-groups.png'
import EthoVerif from '../assets/images/glossary/the-etho-verified.png'
import FairTrade from '../assets/images/glossary/fair-trade.png'
import GiveBack from '../assets/images/glossary/gives-back.png'
import Handmade from '../assets/images/glossary/handmade.png'
import MadeInUSA from '../assets/images/glossary/made-in-the-usa.png'
import Nonprofit from '../assets/images/glossary/non-profit.png'
import Organic from '../assets/images/glossary/contains-organic-material.png'
import Organic100 from '../assets/images/glossary/100-organic.png'
import Recycled from '../assets/images/glossary/recycled-materials.png'
import SustainMats from '../assets/images/glossary/sustainable-materials.png'
import SustainPack from '../assets/images/glossary/sustainable-packaging.png'
import Vegan from '../assets/images/glossary/vegan.png'
import WomanOwned from '../assets/images/glossary/women-owned.png'

class Glossary extends React.Component {
	handleFilter = e => {
		let termsArr = Array.from(
			document.querySelectorAll('#glossary__section .col-lg-3 h4')
		).map(term => {
			return term
		})

		termsArr.filter(term => {
			if (
				!term.innerHTML
					.toLowerCase()
					.includes(e.currentTarget.value.toLowerCase())
			) {
				return term.parentNode.classList.add('hidden')
			} else {
				return term.parentNode.classList.remove('hidden')
			}
		})
	}

	render() {
		return (
			<div className='main-container'>
				<Section className='height-auto'>
					<div className='col-12 text-center'>
						<h2>The Etho's Ethical Glossary</h2>
						<p>
							We also value the following ethical traits that we
							encourage our sellers to meet through their mission,
							production, and organization. Look for these labels
							on your favorite The Etho Products.
						</p>
					</div>
				</Section>

				<Section>
					<div className='col-md-4 active-pink-2'>
						<input
							type='search'
							name='glossary-filter'
							id='glossary__filter'
							placeholder='Search Glossary Terms...'
							onChange={this.handleFilter}
						/>
					</div>
				</Section>

				<Section id='glossary__section'>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={Organic100} alt='Icon of a seedling' />
						<h4>100% Organic</h4>
						<p>
							100% organic items only contain materials that are
							certified organic and are made without the use of
							GMOs, herbicides or pesticides.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={Organic} alt='Icon of a seedling' />
						<h4>Contains Organic Material</h4>
						<p>
							The seller has confirmed that these items contain
							materials that meet organic agricultural standards.
							Farming and production processes do not use GMOs,
							herbicides or pesticides.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={CrueltyFree} alt='Icon of a Bunny' />
						<h4>Cruelty Free</h4>
						<p>
							Cruelty-free products have not been tested on
							animals. Seller has ensured that any animal
							derivatives or by-products are obtained humanely.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={Employs} alt='Icon of a group of people' />
						<h4>Employs Marginalized Groups</h4>
						<p>
							Employs those who are traditionally excluded from
							employment in their community because of gender,
							class, religion, disability, status, and ethnicity.
							Purchases from these brands provide education,
							benefits, and income for these workers.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={FairTrade} alt='Icon of handshake' />
						<h4>Fair Trade</h4>
						<p>
							Fair Trade sellers and products have been audited by
							third-party organizations who certify that producers
							are providing fair working conditions with high
							social and environmental practices.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={EthoVerif} alt='Icon of a checkmark' />
						<h4>The Etho Verified</h4>
						<p>
							The Etho Verified Sellers have gone through our
							ethical verification process to ensure safe and
							ethical working conditions, environmental
							considerations, and payment of minimum wage or
							above.
						</p>
					</div>
					<div
						className='col-lg-3 col-md-6 col-12 text-center'
						style={{ display: 'none' }}>
						<img src={GiveBack} alt='Icon of a cycle arrow' />
						<h4>Gives Back</h4>
						<p>
							Brands that give back donate a portion of purchases
							to charities or organizations aligned with their
							mission.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={Handmade} alt='Icon of a spool' />
						<h4>Handmade</h4>
						<p>
							Handmade items or their main components have been
							handcrafted by skilled artisans using only simple
							tools.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={MadeInUSA} alt='Icon of the USA flag' />
						<h4>Made in the USA</h4>
						<p>
							Products made in the USA support American jobs and
							incur a smaller carbon footprint because of reduced
							shipping distances for American purchases.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img
							src={Nonprofit}
							alt='Icon of a hand holding a heart'
						/>
						<h4>Nonprofit</h4>
						<p>
							Nonprofit brands are not operating for profit. All
							proceeds are dedicated to supporting their mission
							and community.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img
							src={Recycled}
							alt='Icon of a recycling triangle'
						/>
						<h4>Recycled Materials</h4>
						<p>
							These items are made with components sourced from
							waste materials, to minimize the use of virgin raw
							materials.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={SustainMats} alt='Icon of a plant' />
						<h4>Sustainable Materials</h4>
						<p>
							Items made from sustainable materials use natural
							materials that have a minimal environmental impact,
							such as organic cotton, modal, tencel, and hemp.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={SustainPack} alt='Icon of a box' />
						<h4>Sustainable Packaging</h4>
						<p>
							Items that are sustainably packaged come in reusable
							containers or are shipped in minimal or eco-friendly
							packaging.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={Vegan} alt='Icon of the letter V' />
						<h4>Vegan</h4>
						<p>
							The seller has confirmed that their vegan items are
							made without the use of any animal products or by
							products.
						</p>
					</div>
					<div className='col-lg-3 col-md-6 col-12 text-center'>
						<img src={WomanOwned} alt='Icon of the Venus Symbol' />
						<h4>Woman Owned</h4>
						<p>
							Purchases from female-owned brands support women's
							economic empowerment, social equality, and vibrant
							communities.
						</p>
					</div>
				</Section>
			</div>
		)
	}
}

export default Glossary
